<template lang="pug">
router-link.bq-banner(
    v-if="latest"
    :to="`/articles/${latest.slug}`"
)
    span.material-symbols-outlined.bq-banner-icon(translate="no") breaking_news
    span.bq-banner-text
        span.bq-banner-title {{ latest.title }}
        | &nbsp;—&nbsp;
        span.bq-banner-cta.wordset Read More
    span.bq-banner-arrow(translate="no") &rarr;
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { getBannerArticle, type Article } from "@/code/articles";

// Newest article flagged as news, published within the last 30 days, from the
// article list. Null keeps the banner hidden. Selection + windowing live in
// articles.ts.
const latest = ref<Article | null>(null);

onMounted(async () => {
    try {
        latest.value = await getBannerArticle();
    } catch {
        // Non-critical UI: if the list can't be fetched, just show nothing.
    }
});
</script>

<style lang="less" scoped>
@import "@/assets/less/bq-tokens.less";

/* Layout, colours and the icon come from .bq-banner in bq-shared.less; what is
   left here is what only the news banner does. */
.bq-banner {
    transition: border-color 0.15s;

    &:hover {
        text-decoration: none;
        border-color: @success;

        .bq-banner-cta {
            text-decoration: underline;
        }

        .bq-banner-arrow {
            transform: translateX(0.25rem);
        }
    }
}

.bq-banner-title {
    font-weight: 700;
}

.bq-banner-cta {
    opacity: 0.85;
}

.bq-banner-arrow {
    flex: 0 0 auto;
    transition: transform 0.15s;
}
</style>
